import {gql} from '@apollo/client';
import {LibraryAlbumWithSongs} from '../../../../../../graphql/LibraryAlbumWithSongsFragment';
import {CatalogAlbumWithSongs} from '../../../../../../graphql/CatalogAlbumWithSongsFragment';

export const ALBUM_VIEW_ALBUM_QUERY = gql`
  query AlbumViewAlbumQuery($id: String!) {
    me {
      library {
        album(id: $id) {
          ...LibraryAlbumWithSongsFragment
        }
      }
    }
  }
  ${LibraryAlbumWithSongs.libraryAlbum}
`;

export const CATALOG_ALBUM_VIEW_ALBUM_QUERY = gql`
  query CatalogAlbumViewAlbumQuery($id: String!) {
    music {
      album(albumId: $id) {
        ...CatalogAlbumWithSongsFragment
      }
    }
  }
  ${CatalogAlbumWithSongs.catalogAlbum}
`;
